import { useDeviceBreakpoints } from '@/hooks/useDeviceBreakpoints';

import { DrawerNavbar } from './Drawer/DrawerNavbar';
import { TopNavbar } from './Top';

import type { NavbarVariant } from './Top/styles';

interface NavbarProps {
  variant?: NavbarVariant;
}

export function Navbar({ variant = 'primary' }: NavbarProps) {
  const { isTabletOrSmaller } = useDeviceBreakpoints();

  return isTabletOrSmaller ? <DrawerNavbar variant={variant} /> : <TopNavbar variant={variant} />;
}
